<template>
    <div class="wrapper">
        <div class="content">
            <div class="bg"></div>
            <h1 class="title">
                Congratulations, your loan <br> application has been approved
            </h1>
            <p class="caption">
                Based on the information you provided, we have intelligently matched you with the most suitable loan product. Please proceed to get money
            </p>
            <div class="btn-group">
                <a @click="before_click"  href="javascript:void(0);" class="get-money" :class="{'disabled':clicked}">GET MONEY</a>
            </div>                      
        </div>      
        <div class="calculation">                
                    <h3 class="cal-title">Loan Calculation</h3>
                    <div class="cal-table">
                        <div class="cal-head">
                            <div class="cal-head-element">Number of loans</div>
                            <div class="cal-head-element">Loan Amount</div>
                        </div>
                        <div class="cal-row">
                            <div class="cal-element">1</div>
                            <div class="cal-element">1000 - 5000</div>
                        </div>
                        <div class="cal-row">
                            <div class="cal-element">3</div>
                            <div class="cal-element">3000 - 10000</div>
                        </div>
                        <div class="cal-row">
                            <div class="cal-element">5</div>
                            <div class="cal-element">5000 - <strong>40000</strong></div>
                        </div>
                    </div>
                    <div class="cal-caption">Loan calculations are made for you based on your credit evaluation and number of borrowings.</div>
                    <div class="cal-caption">Paying your bills on time increases your credit score</div>
            </div>
    </div>
</template>
<script>
import { onMounted,ref } from 'vue'
import { useRouter } from 'vue-router'
import { bury } from "@api/index";
export default {
    setup () {
        const router = useRouter()
        const route = router.currentRoute     
        let url = ref("")
        let clicked = ref(false)
        onMounted(()=>{
            if(route.value.query.state == 0) {
                //android
                url.value = "https://app.adjust.com/1cbvckgl?redirect=https%3A%2F%2Fdownload.sathikashfin.com%2Fapp%2Fsathikash_2024717.apk"
            } else if (route.value.query.state == 1) {
                url.value = "https://app.adjust.com/1ckjc2s0?redirect=https%3A%2F%2Fdownload.sathikashfin.com%2Fapp%2Fsathikash_2024717.apk"
            }            
            // setTimeout(()=>{
            //     if(url.value && url.value != '') {
            //         window.location.href = url.value
            //     }                
            // }, 2500)            
        })
        const before_click = () => {
            if(clicked.value)return 
            clicked.value = true
            bury({
                "projectName":"Sathi Kash", 
                "pageName":"download",
                "behavior":"clicked",
                "value":"clicked",
                "eventTime":""
            })
            window.location.href = url.value
            setTimeout(()=>{
                clicked.value = false
            },5000)
        }
        return {
            url,
            clicked,
            before_click
        }         
    }
}
</script>
<style lang="less" scoped>
@keyframes scale {
    0%{
        transform: scale(1);
    }  
    50%{
        transform: scale(1.2)
    }  
    100%{
        transform: scale(1)
    }
}
.wrapper{
    background: linear-gradient(360deg, #3890C2 0%, #42A5C4 35%, #59D7C9 100%);
    height: 100vh;
    padding-top: 100px;
    .content{
        width: 610px;
        height: 510px;
        padding:120px 40px 0 40px;
        position: relative;
        background:#fff;
        margin:0 auto;
        border-radius: 20px;;
        .bg{
            position: absolute;
            top:0;
            left:0;
            width: 690px;
            height: 212px;
            background: url("../assets/images/download/rainbow.png") no-repeat;
            background-size:100% 100%;
        }
        .title{
           font-size: 36px;
           color:#333;
           line-height:1.5; 
           margin-bottom: 50px;
           text-align: center;
        }
        .caption{
            font-size: 28px;
            color:#656565;
            line-height:1.5;
            margin-bottom: 50px; 
        }
        .btn-group{
            width: 570px;
            margin:0 auto;
            .get-money{
                display:block;
                width: 570px;
                height: 100px;
                background: #52C9CF;
                border-radius: 8px;
                line-height: 100px;
                text-align: center;
                color:#fff;
                font-size: 30px;                
            }
            .disabled{
                background:#e0e0e0;
                color:#333
            }
        }
    }
}
.estimation{
    position: relative; 
    z-index: 2;                      
    .est-title{
        background:#fff url("../assets/images/audit/banner-2.png") no-repeat;
        background-size: 100%;
        width: 710px;
        height: 182px;
        margin:0 auto;
        text-align: center;
        // padding:50px 0;
        font-size: 32px;
        line-height: 150px;
    }
    .black-placeholder{
        position: absolute;
        top:125px;
        width: 620px;
        height: 10px;
        background:#333;
        margin: 0 auto;
        border-radius: 10px;
        left:75px;
    }                        
    }
    .calculation{
    width: 610px;
    height:530px;
    overflow: hidden;
    background:#fff;                
    border:2px solid #52C9CF;
    // animation: move 1.5s 1s ease-in  forwards;
    padding:40px;
    margin:50px auto;
    border-radius: 20px;
    .cal-title{
        color:#151515;
        font-size: 26px;
        font-weight: 700;
        margin-bottom: 30px;
    }
    .cal-caption{
        font-size: 24px;
        color:#151515;
        line-height:1.5;
        margin-top: 20px;
    }
    .cal-table{
        
        .cal-head{
            display: flex;
            justify-content: space-around;
            align-items: center;
            .cal-head-element{
                text-align:center;
                background:#52C9CF;
                line-height: 60px;
                color:#fff;
                height: 60px;
                font-size: 28px;
                &:first-child{
                    width: 300px;
                    line-height: 60px;
                    margin-right: 2px;
                }
                &:last-child{
                    width: 320px;
                    height: 60px;
                    line-height: 60px;
                }
            }
        }
        .cal-row{
            display: flex;
            justify-content: space-around;
            align-items: center;
            .cal-element{
                margin-top: 5px;
                font-size: 28px;                        
                strong{
                    position: absolute;
                    font-size: 36px;
                    color:#f07807;
                    animation: scale .5s linear infinite ;
                }
                &:first-child{
                    background:#bae0dc;
                    width: 310px;
                    height: 60px;
                    line-height: 60px;
                    color:#151515;
                    margin-right: 2px;
                    text-align:center;
                }
                &:last-child{
                    text-align:left;
                    background:#bae0dc;
                    width: 256px;
                    height: 60px;
                    line-height: 60px;
                    padding-left: 70px;
                    color:#151515
                }
            }
            
        }
    }
    }
</style>